import script from "./RouteItemsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteItemsList.vue?vue&type=script&setup=true&lang=ts"

import "./RouteItemsList.vue?vue&type=style&index=0&id=bd8737c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd8737c4"]])

export default __exports__